import { memo } from "react";
import { RoundIcon } from "./assests/round.icon";
import { ListItem } from "../../../model/bootcamp";

interface Props {
  data: ListItem[];
}

export const List = memo<Props>(({ data }) => {
  return (
    <ul className="lg:grid grid-cols-2 auto-rows-min gap-x-[20px] text-white [&>*:nth-child(2)]:border-b border-solid border-white-opacity-03">
      {data.map((item, index) => (
        <li
          key={index}
          className="lg:first:border-b [&:nth-child(3)]:border-none [&:nth-child(4)]:border-b lg:[&:nth-child(4)]:border-none [&:nth-child(5)]:border-t-[0px] lg:[&:nth-child(5)]:border-t-[1px] lg:[&:nth-child(7)]:border-b last:border-b flex border-t border-solid border-white-opacity-03 pt-8 pb-8 lg:pt-10 lg:pb-10"
        >
          <span className="relative top-[8px] pl-10 pr-9">
            <RoundIcon />
          </span>
          <span // eslint-disable-next-line
            dangerouslySetInnerHTML={{
              __html: item.title,
            }}
          ></span>
        </li>
      ))}
    </ul>
  );
});
